try
{
	new CustomEvent( 'test' );
}
catch ( exception )
{
	/* tslint:disable:variable-name */
	var MyCustomEvent: CustomEventConstructor;
	
	MyCustomEvent = function( event: string, params: CustomEventInit ): CustomEvent
	{
		var eventObject: CustomEvent;
		
		params = params || {
				bubbles: false,
				cancelable: false,
				detail: undefined
			};
		
		eventObject = <CustomEvent>document.createEvent( 'CustomEvent' );
		eventObject.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
		
		return eventObject;
	};
	
	MyCustomEvent.prototype = Event.prototype;
	(<WindowWithCustomEvent>window)['CustomEvent'] = MyCustomEvent;
}

interface WindowWithCustomEvent extends Window
{
	CustomEvent: CustomEventConstructor;
}

type CustomEventConstructor = ( event: string, params: CustomEventInit ) => CustomEvent;
